import { render, staticRenderFns } from "./ViewStudy.vue?vue&type=template&id=3643a892&"
import script from "./ViewStudy.vue?vue&type=script&lang=js&"
export * from "./ViewStudy.vue?vue&type=script&lang=js&"
import style0 from "./ViewStudy.vue?vue&type=style&index=0&id=3643a892&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports